import { render, staticRenderFns } from "./CustomLocationsSection.vue?vue&type=template&id=6a040e28&scoped=true&"
import script from "./CustomLocationsSection.vue?vue&type=script&lang=js&"
export * from "./CustomLocationsSection.vue?vue&type=script&lang=js&"
import style0 from "./CustomLocationsSection.vue?vue&type=style&index=0&id=6a040e28&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a040e28",
  null
  
)

export default component.exports